export default {
  unitSold: {
    id: 'product_page_unit_sold_label',
    defaultMessage: 'Sold last 30 days',
  },
  total: {
    id: 'product_page_unit_sold_plus',
    defaultMessage: '{unit}+',
  },
}
